import { Auth } from 'aws-amplify';

export const updatePassword = async (oldPassword: string, newPassword: string) =>
  await Auth.currentAuthenticatedUser().then((user) => {
    return Auth.changePassword(user, oldPassword, newPassword);
  });
